import axios, { AxiosResponse } from 'axios'
import { getSignedRequest } from 'utils/authUtils'

import {
	PaginatedUsersResponse,
	PatchUserPayload,
	UserResponse,
} from '../models/userModels'

export const verifyAdminPagePassword = async (
	adminPassword: string
): Promise<boolean> => {
	const signed = await getSignedRequest(
		'POST',
		'utility/admin-access',
		JSON.stringify({ adminPassword })
	)

	if (!signed) {
		throw new Error('Unable to get signed request')
	}

	try {
		const response = await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'utility/admin-access',
			data: { adminPassword },
			method: 'POST',
		})
		return response.data?.authorized === true
	} catch (error) {
		if (axios.isAxiosError(error) && error.response?.status === 401) {
			return false
		}
		throw error
	}
}

export const getAllUsers = async (
	params: {
		page?: number
		pageSize?: number
	} = {}
): Promise<AxiosResponse<PaginatedUsersResponse>> => {
	const queryParts: string[] = []
	if (params.page !== undefined) queryParts.push(`page=${params.page}`)
	if (params.pageSize !== undefined)
		queryParts.push(`pageSize=${params.pageSize}`)
	const queryString = queryParts.length ? `?${queryParts.join('&')}` : ''
	const path = `users${queryString}`

	const signed = await getSignedRequest('GET', path)

	if (signed) {
		return await axios({
			...signed,
			url: (process.env.REACT_APP_AWS_API_URL as string) + path,
			method: 'GET',
		})
	}
	throw Error('Unable to get signed request')
}

export const patchUser = async (
	userId: number,
	data: PatchUserPayload
): Promise<AxiosResponse<UserResponse>> => {
	const path = `users/${userId}`
	const signed = await getSignedRequest('PATCH', path, JSON.stringify(data))

	if (signed) {
		return await axios({
			...signed,
			url: (process.env.REACT_APP_AWS_API_URL as string) + path,
			data,
			method: 'PATCH',
		})
	}
	throw Error('Unable to get signed request')
}
